import {VStack} from 'platform/foundation';

import {VideosSection} from './components/VideosSection';

export function DashboardPage() {
  return (
    <VStack spacing={20}>
      <VideosSection />
    </VStack>
  );
}
